import { MeshLambertMaterial, PlaneGeometry, type Texture } from 'three'

export const BALLAST_Y = 0.001
export const BALLAST_PLANE_GEOMETRY = new PlaneGeometry(1, 1)

const BALLAST_MATERIAL_CACHE = new WeakMap<Texture, MeshLambertMaterial>()

export function getBallastMaterial(map: Texture) {
  const cached = BALLAST_MATERIAL_CACHE.get(map)
  if (cached) return cached

  const material = new MeshLambertMaterial({
    map,
    // aoMap: map,
    color: '#999999',
    alphaTest: 0.15,
  })

  BALLAST_MATERIAL_CACHE.set(map, material)
  return material
}

export function getShapeTexture(shapes: string[]): {
  texture: string
  rotationY: number
  mirrorX?: boolean
  scale?: number
  positionYOffset?: number
} {
  if (shapes.length === 1) {
    const s = shapes[0]
    if (s === 'N') return { texture: 'bumper', rotationY: 180, scale: 1.5, positionYOffset: 0.001 }
    if (s === 'S') return { texture: 'bumper', rotationY: 0, scale: 1.5, positionYOffset: 0.001 }
    if (s === 'E') return { texture: 'bumper', rotationY: 90, scale: 1.5, positionYOffset: 0.001 }
    if (s === 'W') return { texture: 'bumper', rotationY: -90, scale: 1.5, positionYOffset: 0.001 }
    if (s === 'NS') return { texture: 'straight', rotationY: 0 }
    if (s === 'WE') return { texture: 'straight', rotationY: 90 }
    if (s === 'NE') return { texture: 'curve', rotationY: 0 }
    if (s === 'SE') return { texture: 'curve', rotationY: -90 }
    if (s === 'SW') return { texture: 'curve', rotationY: 180 }
    if (s === 'NW') return { texture: 'curve', rotationY: 90 }
  }

  if (shapes.length === 2) {
    const sorted = [...shapes].sort().join(',')

    if (sorted === 'SW,WE') return { texture: 'switch-straight-curve', rotationY: 0 }
    if (sorted === 'SE,WE') return { texture: 'switch-straight-curve', rotationY: 0, mirrorX: true }
    if (sorted === 'NW,WE')
      return { texture: 'switch-straight-curve', rotationY: 180, mirrorX: true }
    if (sorted === 'NE,WE') return { texture: 'switch-straight-curve', rotationY: 180 }
    if (sorted === 'NS,SW')
      return { texture: 'switch-straight-curve', rotationY: -90, mirrorX: true }
    if (sorted === 'NS,SE')
      return { texture: 'switch-straight-curve', rotationY: 90, mirrorX: true }
    if (sorted === 'NS,NW')
      return { texture: 'switch-straight-curve', rotationY: -90, mirrorX: true }
    if (sorted === 'NE,NS')
      return { texture: 'switch-straight-curve', rotationY: 90, mirrorX: true }

    if (sorted === 'NW,SW') return { texture: 'switch-curve-curve', rotationY: 0 }
    if (sorted === 'NE,NW') return { texture: 'switch-curve-curve', rotationY: -90 }
    if (sorted === 'NE,SE') return { texture: 'switch-curve-curve', rotationY: 180 }
    if (sorted === 'SE,SW') return { texture: 'switch-curve-curve', rotationY: 90 }
    if (sorted === 'NE,SW') return { texture: 'switch-curve-curve', rotationY: 45 }
    if (sorted === 'NW,SE') return { texture: 'switch-curve-curve', rotationY: -45 }
  }

  if (shapes.length === 3) {
    return { texture: 'switch-3', rotationY: 0 }
  }

  return { texture: 'straight', rotationY: 0 }
}

export const TEXTURE_PATHS: Record<string, string> = {
  straight: '/textures/ballast/straight.png',
  curve: '/textures/ballast/curve.png',
  'switch-straight-curve': '/textures/ballast/switch-straight-curve.png',
  'switch-curve-curve': '/textures/ballast/switch-curve-curve.png',
  'switch-3': '/textures/ballast/switch-3.png',
  bumper: '/textures/ballast/bumper.png',
}
